export const SUCCESS_CREATED = 'SUCCESS_CREATED';
export const SUCCESS_UPDATED = 'SUCCESS_UPDATED';

export const SUCCESS_MPOWER_CREATED = 'SUCCESS_MPOWER_CREATED';
export const SUCCESS_MPOWER_UPDATED = 'SUCCESS_MPOWER_UPDATED';

export const BAD_LOAD = 'BAD_LOAD';
export const BAD_UPDATE = 'BAD_UPDATE';
export const BAD_CREATE = 'BAD_CREATE';
export const BAD_REMOVE = 'BAD_REMOVE';

export const BAD_MPOWER_LOAD = 'BAD_MPOWER_LOAD';
export const BAD_MPOWER_UPDATE = 'BAD_MPOWER_UPDATE';
export const BAD_MPOWER_CREATE = 'BAD_MPOWER_CREATE';
export const BAD_MPOWER_REMOVE = 'BAD_MPOWER_REMOVE';

export const GET_ALL_SUPPLIERS = 'GET_ALL_SUPPLIERS';

export const UPDATE_DISCOUNT_PENDING = 'UPDATE_DISCOUNT_PENDING';
export const GET_ALL_DISCOUNTS = 'GET_ALL_DISCOUNTS';
export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT';
export const CREATE_DISCOUNT = 'CREATE_DISCOUNT';

export const UPDATE_MPOWER_DISCOUNT_PENDING = 'UPDATE_MPOWER_DISCOUNT_PENDING';
export const GET_ALL_MPOWER_DISCOUNTS = 'GET_ALL_MPOWER_DISCOUNTS';
export const UPDATE_MPOWER_DISCOUNT = 'UPDATE_MPOWER_DISCOUNT';
export const CREATE_MPOWER_DISCOUNT = 'CREATE_MPOWER_DISCOUNT';

export const UPDATE_USER_ROLES_PENDING = 'UPDATE_USER_ROLES_PENDING';
export const GET_ALL_USER_ROLES = 'GET_ALL_USER_ROLES';

export const UPDATE_USER_PENDING = 'UPDATE_USER_PENDING';
export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS';
export const UPDATE_USER = 'SET_USER';
export const UPDATE_LOCAL_USER = 'UPDATE_LOCAL_USER';

export const GET_DISTRIBUTOR = 'GET_DISTRIBUTOR';
export const GET_DISTRIBUTOR_LOADING = 'GET_DISTRIBUTOR_LOADING';
